<div class="hero_area2">
    <app-menu [config]="config"></app-menu>
    <!-- <app-carrossel [config]="config"></app-carrossel> -->
</div>
<app-produto-categoria-body [config]="config"></app-produto-categoria-body>